import React, { PropTypes, Component } from 'react';

class ShowCategoryTemplateThree extends Component {
  handleClick(e) {
    e.preventDefault();
  }
  render() {
    const showTermMeta = (TermMeta, index) => {
      const imgStyle = {
        backgroundImage: 'url(' + TermMeta.thumbnail_image.image_big_url + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      };
      return (<div className="category-with-img" key={'metaKey-' + index}>
        <a href={this.props.taxonomy.permalink} style={imgStyle} className="category-normal">
          <div className="img-overlay"></div>
          <h5>{this.props.taxonomy.value}</h5>
          <div className="post-text"><p>{this.props.taxonomy.description.slice(0, 100)}</p></div>
        </a>
      </div>);
    };
    const imgStyle = {
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    };
    return (
      <div className="rq-image-grid">
          {this.props.taxonomy.term_meta ? this.props.taxonomy.term_meta.map(showTermMeta) : '' }
          {this.props.taxonomy.term_meta.length === 0 ?
          <div className="category-with-img" >
            <a href={this.props.taxonomy.permalink} style={imgStyle} className="category-normal">
            <div className="img-overlay"><i className="fa fa-frown-o"></i></div>
            <h5 className={ this.props.taxonomy.description ? 'with-desc' : '' }>{this.props.taxonomy.value}</h5>
            <div><p>{this.props.taxonomy.description.slice(0, 100)}</p></div>
           </a>
          </div> : null}
      </div>
    );
  }
}
ShowCategoryTemplateThree.propTypes = {
  'taxonomy': React.PropTypes.object,
};
ReactiveTemplateCategories['showCategoryTemplateThree'] = ShowCategoryTemplateThree;

ReactiveCategories.push({
  'key': 'showCategoryTemplateThree',
  // 'image_url': API.IMG + 'effect-steve.jpg',
  'type': 'all',
});



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/block/category/showCategoryTemplateThree.js